<style>
.radio>label {
  font-size: 13px;
}

.zoom {
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
}
</style>
<template>
<div>
  <v-radio-group v-model="inputValue" :loading="loading">
    <v-row dense v-for="item in items" :key="item.paymentInstrument" mt-3>
      <v-col cols="9">
        <v-radio class="radio" :key="item.paymentInstrument" :label="item.label.cs" :value="item"></v-radio>
      </v-col>
      <v-col cols="3" class="zoom text-right">
        <img :src="item.image.normal">
      </v-col>
    </v-row>
  </v-radio-group>
</div>
<!-- <v-select cache-items :loading="loading" :items="items" v-model="selected" single-linemenu-props="bottom"required
    item-text="label"
    :no-data-text="$t('Žádná platební metoda')" @change="onChange">
    <template slot="selection" slot-scope="data">
      <v-col class="text-left">{{ data.item.label.cs }}</v-col>
      <v-col class="text-right"><img :src="data.item.image.normal"></v-col>
    </template>
    <template slot="item" slot-scope="data">
      <v-list-item-content>
        <v-list-item-title>
          <v-col class="text-left">{{ data.item.label ? data.item.label.cs : '' }}</v-col>
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item v-if="data.item.image">
        <img :src="data.item.image.normal">
      </v-list-item>
    </template>
  </v-select> -->
</template>
<script>
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

export default {
  mixins: [TransformMixin],
  data() {
    return {
      items: [],
      // selected: null,
      loading: false
    }
  },
  mounted() {
    if (this.items.length === 0) {
      this.loading = true
      this.$fetch('my/institutions/payment-instruments').then(data => {
        this.items = data
        if (this.items.length > 0) {
          this.inputValue = this.items[0]
          // this.onChange(this.items[0])
        }
      }).catch(() => console.log('payment instruments error')).finally(() => this.loading = false)
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.items[0]
      },
      set(value) {
        this.$emit('paymentInstrument', value)
      }
    }
  }
  // ,
  // methods: {
  //   onChange(value) {
  //     this.$emit('paymentInstrument', value)
  //   }
  // }
}
</script>
